// COCHE §10.1.10 — English (Hong Kong). Mirror the keys in zh_cn.ts.
export default {
	common: {
		save: "Save",
		cancel: "Cancel",
		delete: "Delete",
		edit: "Edit",
		search: "Search",
		export: "Export",
		import: "Import",
		confirm: "Confirm",
		yes: "Yes",
		no: "No",
		add: "Add",
		back: "Back",
		close: "Close",
		operation: "Operation",
		loading: "Loading…",
		empty: "No data",
		opSuccess: "Operation successful",
		opFailed: "Operation failed",
		submit: "Submit",
		reset: "Reset",
		reload: "Reload",
		view: "View",
		more: "More",
		all: "All",
		tip: "Notice",
		confirmDelete: "Delete this item?",
		pleaseSelect: "Please select",
		loadFailed: "Failed to load",
		downloadSuccess: "Downloaded",
		warning: "Warning",
		operationSuccess: "Done",
		pleaseInput: "Please enter",
		deleteSuccess: "Deleted",
		editSuccess: "Edited successfully",
		addSuccess: "Added successfully",
		viewSource: "OCR source",
		confirmDeleteRecord: "Delete this record?",
		recordSeqHeader: "No.",
		detail: "Details",
		requiredFieldHint: "Missing required fields. Tap submit again to jump to the first one.",
	},
	auth: {
		sessionExpired: "Your session has expired. Please sign in again.",
		permissionDenied: "You don't have permission for this action.",
		networkError: "Can't reach the server. Please check your connection.",
		serverUnavailable: "The server is temporarily unavailable. Please try again later.",
	},
	login: {
		title: "Sign in",
		username: "Username",
		password: "Password",
		submit: "Sign in",
		captcha: "Captcha",
		rememberMe: "Remember me",
		welcome: "Welcome back",
		signIn: "Sign in",
		platformTitle: "Clinical Research Database",
		platformTagline: "Efficient, flexible clinical-research data captured end-to-end.",
		sxswTitle: "Shaanxi Neurosurgery Quality Control Centre — Data Capture System",
		bgAlt: "Background",
		tabPassword: "Password",
		tabSms: "SMS code",
		tabWechat: "WeChat QR",
		usernamePh: "Please enter your username",
		passwordPh: "Please enter your password",
		mobilePh: "Please enter your mobile number",
		smsCodePh: "Please enter the SMS code",
		captchaPh: "Captcha",
		invalidMobile: "Please enter a valid 11-digit mobile number",
		getCode: "Get code",
		resendCode: "Resend in {sec}s",
		smsSent: "SMS code sent successfully",
		copyright: "© 2026 Beijing IMLES Technology Co., Ltd. ICP filing 19052789-1",
		icpFiling: "Beijing PSB filing 11011302007191",
		platformTitleMycoach: "Clinical Data Platform",
		platformTaglineMycoach: "Unlock Clinical Data",
		copyrightMycoach: "© 2026 Mycoach Health Limited. All rights reserved. Compliant with HIPAA and PIPEDA standards.",
	},
	nav: {
		dashboard: "Dashboard",
		patients: "Patients",
		projects: "Projects",
		schema: "Schema",
		governance: "Governance",
		settings: "Settings",
		logout: "Sign out",
	},
	locale: {
		switcher: "Language",
		en_hk: "English",
		zh_hk: "繁體中文",
		zh_cn: "简体中文",
	},
	i18n: {
		schemaTranslate: {
			title: "Schema translation",
			scanProject: "Scan project for gaps",
			draftWithLlm: "Draft with LLM",
			applySelected: "Save selected",
			columnSource: "Source",
			columnSuggestion: "LLM draft",
			columnEdited: "Your edit",
			noMissing: "All schema labels for this project are already translated.",
		},
	},
	imaging: {
		title: "Imaging viewer",
		subtitle: "COCHE Tier-B — B2 viewer · B4 annotation (cvd_hk)",
		studies: "Studies",
		series: "Series",
		viewer: "Viewer",
		reload: "Reload",
		loading: "Loading…",
		prev: "Prev",
		next: "Next",
		workspace: "Workspace",
		metadata: "Metadata",
		task: "Task",
		noImaging: "No imaging for this patient",
		selectSeries: "Select a series",
		layersShort: "layers",
		frame: "Frame",
		slice: "Slice",
		phase: "Phase",
		axial: "Axial",
		coronal: "Coronal",
		sagittal: "Sagittal",
		play: "Play",
		pause: "Pause",
		wlAuto: "auto",
		wlCustom: "custom",
		zoom: "Zoom",
		reset: "Reset",
		aiSegment: "AI segment this volume",
		segStarted: "Segmentation started on {backend}",
		saving: "Saving…",
		frameUnavailable: "Frame not available (pixels not cached)",
		layers: "Layers",
		newLayer: "New layer",
		noLayers: "No annotation layers yet",
		opacity: "Opacity",
		delete: "Delete",
		deleteLayerConfirm: "Delete layer #{id}? This cannot be undone.",
		tools: "Drawing tools",
		toolNone: "Pan",
		toolBrush: "Brush",
		toolEraser: "Eraser",
		toolPolygon: "Polygon",
		toolGrow: "Region grow",
		radius: "Radius",
		tolerance: "Tolerance",
		toolHint: "Brush / eraser: drag. Polygon: click points, double-click to close. Region grow: click a seed pixel. Every stroke is saved to the selected label.",
		readOnlyLayer: "This layer is read-only (only your own draft layers can be edited).",
		submitReview: "Submit for review",
		submitConfirm: "Submit your layer? It becomes read-only and agreement with the other reader is computed once everyone has submitted.",
		submitted: "Submitted",
		phiRemoved: "PHI removed on ingest",
		chooseLabels: "Choose labels",
		labelName: "Label name",
		addLabel: "Add label",
		cancel: "Cancel",
		create: "Create",
	},
	imagingWs: {
		title: "Imaging workspace",
		subtitle: "COCHE Tier-B — studies · upload · AI segmentation jobs · annotation tasks",
		noProject: "No project selected — open this page from a project, or add ?projectId= to the URL.",
		reload: "Reload",
		upload: "Upload",
		purge: "Purge project imaging data",
		purgeConfirm: "Delete EVERY study, series, annotation and task of this project's imaging module? This is irreversible.",
		purged: "Purged {n} series",
		tabStudies: "Studies",
		tabJobs: "Jobs",
		tabTasks: "Annotation tasks",
		patient: "Patient",
		date: "Date",
		modality: "Modality",
		description: "Description",
		seriesCount: "Series",
		instances: "Instances",
		series: "Series",
		frames: "Frames",
		kind: "Kind",
		annotations: "Layers",
		actions: "Actions",
		openViewer: "Open viewer",
		aiSegment: "AI segment",
		delete: "Delete",
		deleted: "Deleted",
		deleteConfirm: "Delete \"{name}\"? This cannot be undone.",
		uploadTitle: "Upload imaging (DICOM / NIfTI / images)",
		uploadDrop: "Drop files here or click to select",
		uploadHint: "DICOM (.dcm, folders), NIfTI (.nii / .nii.gz), PNG / JPEG. Patient identifiers are removed on ingest.",
		chooseFolder: "Choose folder…",
		patientNoOpt: "Patient no. (optional)",
		files: "files",
		clear: "Clear",
		startUpload: "Start upload",
		close: "Close",
		job: "Job",
		file: "File",
		bytes: "Size",
		status: "Status",
		reason: "Reason",
		backend: "Backend",
		progress: "Progress",
		createdBy: "Created by",
		started: "Started",
		duration: "Duration",
		error: "Error / result",
		jobStarted: "Job #{id} started on {backend}",
		segmentTitle: "AI segmentation (TotalSegmentator)",
		segmentTask: "Task",
		start: "Start",
		cancel: "Cancel",
		newTask: "New annotation task",
		taskTitle: "Title",
		readers: "Readers",
		adjudicator: "Adjudicator",
		threshold: "Dice threshold",
		labels: "Labels",
		assigneesHint: "Comma-separated user names, e.g. coche_researcher, coche_admin",
		create: "Create",
		created: "Task created — one draft layer per reader",
		open: "Open",
		adjudicate: "Adjudicate",
		adjudicationTitle: "Adjudication",
		gold: "Gold",
		needTwoReaders: "This task needs two reader layers to adjudicate.",
		readerA: "Reader A",
		readerB: "Reader B",
		diff: "Difference",
		agree: "agree",
		only: "only",
		jumpAnnotated: "Jump to annotated frame",
		perLabelDice: "Per-label agreement",
		decision: "Decision",
		noteOpt: "Note (optional)",
		acceptA: "Accept A as gold",
		acceptB: "Accept B as gold",
		editA: "Edit A → gold",
		editB: "Edit B → gold",
		notDisputed: "Task is {status} — decisions are only possible while disputed.",
		notAdjudicator: "Only the adjudicator ({user}) can decide this task.",
		adjudicated: "Adjudicated",
		goldLayer: "Gold layer",
		openInViewer: "Open in viewer",
	},
	ml: {
		title: "Federated learning & model registry",
		subtitle: "Flower FedAvg across sites — only model weights cross the wire; no patient rows leave a site",
		reload: "Reload",
		startRun: "Start federated run",
		rounds: "rounds",
		minClients: "min sites",
		liveRun: "run in progress",
		runs: "Federated runs",
		noRuns: "No federated runs yet",
		status: "Status",
		roundsDone: "Rounds",
		sites: "Sites",
		waitingClients: "waiting for sites to connect…",
		bytes: "Bytes sent",
		auc: "AUC",
		loss: "Loss",
		started: "Started",
		runDetail: "Run detail",
		live: "live",
		rowsTransferred: "Rows transferred",
		site: "Site",
		city: "City",
		jurisdiction: "Jurisdiction",
		nSamples: "N",
		joinCommand: "Join command for a new site",
		copy: "Copy",
		copied: "Copied",
		chartTitle: "Per-site loss (solid) and global-model AUC (dashed) per round",
		round: "Round",
		models: "Model registry",
		noModels: "No registered models",
		name: "Name",
		version: "Version",
		algorithm: "Algorithm",
		artifactSha: "Artifact SHA-256",
		job: "Job",
		stage: "Stage",
		actions: "Actions",
		toStaging: "Stage",
		toProduction: "Promote to production",
	},
	timeseries: {
		title: "Physiological signals",
		streams: "Streams",
		viewer: "Viewer",
		reload: "Reload",
		live: "Live",
		ingestRate: "Ingest rate",
	},
	interop: {
		title: "FHIR / OMOP interoperability",
		framing: "FHIR R4 export layer / OMOP CDM v5.4 export — a HAPI FHIR server and an OHDSI ETL are the production deployment form.",
		coverage: "Mapping coverage",
		fields: "fields",
		mapped: "mapped",
		review: "review",
		unmapped: "unmapped",
		perModel: "Per model",
		model: "Model",
		conceptMap: "Concept map",
		field: "Field",
		target: "Target",
		resource: "Resource / table",
		element: "Element / column",
		vocabulary: "Vocabulary",
		code: "Code",
		conceptId: "OMOP concept_id",
		display: "Display",
		unit: "Unit",
		status: "Status",
		note: "Note",
		search: "Search field / code / display",
		save: "Save",
		cancel: "Cancel",
		edit: "Edit",
		saved: "Mapping saved",
		reseed: "Reset to seed",
		reseedConfirm: "Re-apply the shipped seed mapping? Manual edits will be overwritten.",
		lookup: "Value lookups",
		domain: "Domain",
		sourceValue: "Source value",
		fhir: "FHIR R4 bundle",
		patient: "Patient",
		pickPatient: "Select a patient",
		viewBundle: "View FHIR bundle",
		openRaw: "Open raw $everything",
		validate: "Validate project",
		validating: "Validating all patients…",
		resources: "Resources",
		valid: "valid",
		invalid: "invalid",
		bundleValid: "Bundle validates against fhir.resources R4B",
		bundleInvalid: "Bundle failed validation",
		omop: "OMOP CDM v5.4",
		download: "Download OMOP CDM (zip)",
		preview: "Preview tables",
		rows: "rows",
		table: "Table",
		reload: "Reload",
		loading: "Loading…",
		noProject: "Select a project first",
		collapseAll: "Collapse all",
		expandAll: "Expand all",
	},
	encryption: {
		title: "Encryption status",
		enabled: "Enabled",
		disabled: "Disabled",
		mysql: "MySQL",
		reload: "Reload",
		encryptAll: "Encrypt all",
		decryptAll: "Decrypt all",
	},
	header: {
		maskedHospital: "**** Hospital",
		systemAdminConsole: "System Admin Console",
		switchTenant: "Switch Tenant",
		configForm: "Configure Form",
		switchProject: "Switch Project",
		setPassword: "Set Password",
		changePassword: "Change Password",
		avatarSettings: "Avatar Settings",
		settings: "Settings",
		logout: "Sign out",
		oldPassword: "Old password",
		newPassword: "New password",
		confirmPassword: "Confirm password",
		enterOldPassword: "Please enter the old password",
		enterNewPassword: "Please enter the new password",
		enterConfirmPassword: "Please re-enter the new password",
		passwordMismatch: "Passwords do not match",
		tenantCodePrompt: "Enter tenant code (must be a valid tenant code)",
		passwordSetSuccess: "Password set. Please sign in again.",
		passwordChangeSuccess: "Password changed. Please sign in again.",
		compactMode: "Compact mode",
		compactModeDesc: "Form fields laid out horizontally with tighter line spacing",
		darkMode: "Dark mode",
		darkModeDesc: "Local-only; persists across reload",
		dataMasking: "Data masking",
		dataMaskingDesc: "Hide sensitive fields in lists/forms",
		fontTheme: "Font theme",
		fontThemeDesc: "Pick a modern type pairing for English and Chinese — local-only, applies instantly",
		fontThemeModern: "Modern",
		fontThemeEditorial: "Editorial",
		fontThemeFriendly: "Friendly",
		betaSuffix: " (BETA)",
		languageDesc: "Interface language; the page reloads when you switch",
		changePasswordDesc: "Update your sign-in password; you will be signed out after the change",
		avatarSettingsDesc: "Upload or replace your avatar image",
		modify: "Modify",
		displayName: "Display name",
		displayNameDesc: "The name shown across the app; your login username can't be changed",
		editDisplayName: "Edit display name",
		displayNamePlaceholder: "Enter a display name",
		displayNameRequired: "Please enter a display name",
		displayNameLength: "Display name must be 1–120 characters",
		displayNameUpdated: "Display name updated",
		sectionAccount: "Account",
		sectionAppearance: "Appearance",
		sectionPrivacy: "Privacy",
	},
	followup: {
		title: "Follow-ups",
		statTotalCase: "Total cases",
		statMonthlyDue: "Visits due this month",
		statMonthlyDone: "Visits completed this month",
		statMonthlyOpen: "Visits outstanding this month",
		searchDate: "Visit date:",
		searchStatus: "Status:",
		searchPatient: "Patient name / ID:",
		startDate: "Start",
		endDate: "End",
		select: "Select…",
		input: "Type here",
		searchBtn: "Search",
		resetBtn: "Reset",
		colIndex: "No.",
		colVisitPlan: "Visit plan",
		colPatientName: "Patient",
		colPatientNo: "Patient ID",
		colVisitDate: "Visit date",
		colVisitName: "Visit",
		colStatus: "Status",
		colCenter: "Centre",
		colOperation: "Actions",
		actEdit: "Edit",
		actView: "View",
		actCancel: "Cancel visit",
		statusPending: "Pending",
		statusOverdue: "Overdue",
		statusDone: "Done",
		fieldKeyword: "Type to search",
		detailTitle: "Follow-up detail",
	},
	multicenter: {
		overviewTitle: "Multi-centre overview",
		patientTitle: "Multi-centre patients",
		followupTitle: "Multi-centre follow-ups",
		colCenter: "Centre",
		colTenant: "Tenant",
		colPatientCount: "Patients",
		colFollowupCount: "Follow-ups",
		colCompleteness: "Completeness",
		switchProject: "Switch project",
		statCenters: "Centres",
		statPatients: "Total patients",
		statFollowups: "Total visits",
		statOverdue: "Overdue visits",
		newPatientTrend: "New patient trend",
		today: "Today",
		thisWeek: "This week",
		thisMonth: "This month",
		thisYear: "This year",
		startDate: "Start date",
		endDate: "End date",
		dateSep: "to",
		centerPatientCount: "Patients per centre",
		colRank: "Rank",
		colCenterName: "Centre",
		colUserCount: "Users",
		colPatientCountAlt: "Patients",
		patientGender: "Patient gender",
		mcInfo: "Multi-centre info",
		caseCount: "Cases",
		departmentCount: "Departments",
		mapCenters: "Centre map",
		mapPatients: "Patient distribution",
		caseFilter: "Filter by case count",
		all: "All",
		hospitalName: "Hospital:",
		departmentName: "Department:",
		projectName: "Project:",
		patientCountLabel: "Cases:",
		emptyData: "No data",
	},
	manage: {
		auditLog: "Audit log",
		piiRule: "PII rule config",
		governanceInbox: "Approval inbox",
		myRequests: "My requests",
		scopeTree: "Org chart",
		lifecycle: "Lifecycle",
		metadataVersioning: "Schema versions",
		ingestionHardening: "Ingestion guard",
		ehealth: "eHealth upload",
		subCenter: "Sub-centres",
		schema: "Schema gen",
		agentConfig: "Agent config",
		random: "Randomisation",
		consent: "Consent forms",
	},
	databaseConfig: {
		patientBasicInfo: "Patient basic info",
		databaseSection: "Database configuration",
		followupSection: "Follow-up forms",
		colNo: "No.",
		colFormCode: "Form code",
		colFormName: "Form name",
		colModelCount: "Models",
		colOp: "Actions",
		colFollowupCode: "Follow-up form code",
		colFollowupName: "Follow-up form name",
		colFollowupPlan: "Linked follow-up plan",
		colFollowupPlanName: "Linked plan name",
		btnAdd: "Add",
		btnBatchAdd: "Batch add",
		btnDelete: "Delete",
		btnEdit: "Edit",
		btnConfig: "Configure",
		btnConfigFromTemplate: "From template",
		btnConfigFromForm: "From project form",
		dlgEditTitle: "Edit",
		dlgAddTitle: "Add",
		dlgEditFollowupTitle: "Edit follow-up form",
		dlgAddFollowupTitle: "Add follow-up form",
		dlgFormName: "Form name",
		dlgFollowupName: "Follow-up form name",
		dlgPh: "Please enter",
		dlgCancel: "Cancel",
		dlgConfirm: "Confirm",
	},
	memberPermissions: {
		title: "Members & permissions",
		colNo: "No.",
		colTenant: "Tenant",
		colUsername: "Username",
		colNickname: "Nickname",
		colFuncPermission: "Function permission",
		colDataPermission: "Data permission",
		colActions: "Actions",
		btnConfigure: "Configure",
		btnEdit: "Edit",
		noRolesAssigned: "(no roles)",
		scopeCount: "Scope: {f} form(s) · {m} model(s)",
		actEditRoles: "Edit function permission",
		actEditData: "Edit data permission",
		actRemove: "Remove",
		confirmRemove: "Remove this user from the project?",
		dlgAddTitle: "Add member",
		addHint: "Search by exact username, employee number, or mobile to add a member. Set function and data permissions afterwards.",
		searchPh: "Type exact username / employee no / mobile…",
		searchNoMatch: "No matching user — check spelling or use exact ID",
		lblAccount: "Account",
		btnAddAnother: "Add another",
		dlgFuncTitle: "Function permission",
		projectRolesLabel: "Project-scoped roles (managed here)",
		globalRolesLabel: "Globally-effective roles (managed in user admin)",
		globalRolesHint: "These roles are assigned at the user level and apply to every project. Edit them in the user admin page, not here.",
		projectRolesEmptyButGlobal: "No project-scoped roles assigned. This user's effective permissions on this project come entirely from the global roles above. Add a role here to give them additional permissions scoped to this project only.",
		projectRolesEmptyNoGlobal: "No roles assigned to this user yet. Pick one or more above to grant project-scoped access.",
		dlgDataTitle: "Data permission",
		dataBypassModelAdmin: "Heads-up: this user has the Model Administrator role and bypasses the data-permission filter entirely. The selections below are saved but have no effect at view time — they only apply to users without Model Administrator.",
		dataBypassProjectCreator: "Heads-up: this user is the project creator and bypasses the data-permission filter entirely. The selections below are saved but have no effect at view time — project creators always see all forms and models.",
		sodWarnTitle: "Separation-of-duties warning ({n} conflicts) — you may still save",
		sodErrorTitle: "Separation-of-duties violation ({n} conflicts) — enforce mode is on, save blocked",
		sodEnforceBlocked: "Separation-of-duties violation — remove the conflicting roles before saving",
		sodWarnSaved: "Saved with {n} separation-of-duties warning(s)",
	},
	sod: {
		tagPending: " (pending)",
		tagAssigned: " (assigned)",
		violationLine: "{a} conflicts with {b} ({classA} × {classB})",
	},
	scopeTree: {
		filterTenantPh: "Filter by tenant code",
		visibilityTitle: "My scope visibility",
		visibilityPrompt: "Click Reload to query the current session's visible project set.",
		fUserId: "User ID",
		fBypass: "Bypass filter",
		bypassYes: "Yes (bypass)",
		bypassNo: "No (enforced)",
		fReason: "Reason",
		fScopePaths: "Scope paths",
		noScopePath: "— no scope_path assigned —",
		fAllowedProjects: "Visible project IDs",
		bypassAll: "— bypass: all visible —",
		noVisibleProject: "No visible projects (allowed-set is empty)",
		emptyTree: "No organisation data yet",
		rootLabel: "All organisations",
		tagDefault: "Default",
		tagProjectCount: "{n} project(s)",
		truncated: "Results truncated (>1000 nodes). Use the per-level endpoint to paginate.",
		selectHint: "Select a node on the left to view its details.",
		dKind: "Level",
		dCode: "Code",
		dTenant: "Tenant",
		dRegulatory: "Regulatory jurisdiction",
		dFederation: "Federation mode",
		dAddress: "Address",
		dCountry: "Country",
		dRegion: "Region",
		dMission: "Mission",
		dProjectCount: "Projects",
	},
	auditLog: {
		title: "Audit log",
		refresh: "Refresh",
		startDate: "From",
		endDate: "To",
		category: "Category",
		verb: "Verb",
		targetType: "Target type",
		outcome: "Outcome",
		actorUserId: "Actor ID",
		dataSubjectId: "Data subject ID (GDPR)",
		targetProjectCode: "Project code",
		search: "Search",
		reset: "Reset",
		empty: "No audit logs",
		colTime: "Time",
		colActor: "Actor",
		colApp: "Source",
		colCategory: "Category",
		colVerb: "Verb",
		colTarget: "Target",
		colOutcome: "Outcome",
		colDetail: "Detail",
		view: "View",
		drawerTitle: "Audit log detail",
		eventSection: "Event",
		complianceSection: "Compliance metadata (GDPR readiness)",
		integritySection: "Integrity (hash chain)",
		fId: "ID",
		fTime: "Time",
		fActor: "Actor",
		fIp: "IP",
		fApp: "Source",
		fCategory: "Category / Verb",
		fOutcome: "Outcome",
		fFailureReason: "Failure reason",
		fTarget: "Target",
		fProject: "Project",
		fLawful: "lawful_basis",
		fSubject: "data_subject_id",
		fCrossBorder: "cross_border_transfer",
		yes: "Yes",
		no: "No",
		fDestCountry: "destination_country",
		fPrev: "prev_log_hash",
		fThis: "this_log_hash",
		changeRefSection: "Linked change record",
		loadChange: "Load change detail",
		fTable: "Table/Collection",
		fPk: "Primary key",
		fOp: "Op",
		loadChangeFailed: "Failed to load change detail",
	},
	metaVer: {
		intro: "Read-only view of <a href=\"/api/cmdb-template/doc.html#/cmdb-metadata\" target=\"_blank\">/cmdb-metadata</a>. Version/history snapshots roll out via spec §3's three-phase switches. See <code>extract/coche/specs/metadata-versioning.md</code>.",
		tabLog: "Evaluation log (shadow+exec)",
		tabTags: "Tags",
		tabAdapters: "Format adapters",
		colTarget: "Target",
		colPriorVer: "Prior ver.",
		colNote: "Note",
		colCode: "Code",
		colTag: "Tag",
		colDescription: "Description",
		colCreated: "Created",
		colExtensions: "Extensions",
		colName: "Name",
		colEnabled: "Enabled",
		on: "On",
		off: "Off",
	},
	lifecyclePage: {
		intro: "Read-only view of <a href=\"/api/cmdb-template/doc.html#/cmdb-lifecycle\" target=\"_blank\">/cmdb-lifecycle</a>. Policies and legal holds are created via the API; execution flows through the approval workflow (§10.1.3). See <code>extract/coche/specs/lifecycle-retention.md</code>.",
		tabPolicies: "Retention policies",
		tabHolds: "Legal holds",
		tabLog: "Evaluation log (shadow+exec)",
		colTargetType: "Target type",
		colRetentionDays: "Retention (d)",
		colAgeAnchor: "Age anchor",
		colAction: "Action",
		colEnabled: "Enabled",
		colDescription: "Description",
		on: "On",
		off: "Off",
		colScope: "Scope",
		colTargetId: "Target ID",
		colReason: "Reason",
		colImposed: "Imposed",
		colReleased: "Released",
		active: "Active",
		colAgeDays: "Age (d)",
		colRequest: "Request",
		colNote: "Note",
	},
	dataSync: {
		title: "Daily data updates",
		reload: "Reload",
		range7d: "7 days",
		range30d: "30 days",
		range90d: "90 days",
		todayNewPatients: "New patients today",
		todayUnits: "Follow-up units today",
		last7d: "Last 7 days",
		backlog: "Backlog units",
		backlogHint: "Enumerated but not yet written",
		latestRun: "Latest run",
		noRuns: "No runs yet",
		noData: "No data",
		chartTitle: "Daily update trend",
		seriesUnits: "Follow-up units",
		seriesPatients: "New patients",
		seriesErrors: "Errors",
		runHistory: "Run history",
		colBatch: "Batch",
		colPhase: "Phase",
		colStatus: "Status",
		colStarted: "Started",
		colEnded: "Ended",
		colDone: "Done",
		colSkip: "Skipped",
		colEmpty: "Empty",
		colErrors: "Errors",
		colNewPatients: "New patients",
		colDocuments: "Documents",
		colNote: "Note",
		detailTitle: "Run detail",
		cacheHits: "cache hits",
		unrouted: "Unrouted examination items",
		unmappedEnums: "Unmapped enum values",
		unmappedEnumValues: "Dropped enum values",
		enumSynonym: "Matched via synonym",
		enumCatchAll: "Bucketed as catch-all",
		unknownModels: "Unknown models",
		multiRecordDropped: "Multi-record data dropped",
		activeFilterSkipped: "Active-row filter skipped",
		numericPercent: "Numeric: percent sign stripped",
		numericDecimal: "Numeric: decimal in an integer field",
		numericThreshold: "Numeric: threshold value refused",
		numericUnit: "Numeric: value with unit refused",
		numericList: "Numeric: multi-value refused",
		numericQualitative: "Numeric: qualitative answer refused",
		numericThresholdValue: "Numeric: threshold values",
		numericUnitValue: "Numeric: values with units",
		numericListValue: "Numeric: multi-values",
		numericQualitativeValue: "Numeric: qualitative answers",
		groupTruncated: "{n} more not shown",
		scalars: "Other counters",
		colItem: "Item",
		colCount: "Count",
		status: {
			running: "Running",
			completed: "Completed",
			aborted: "Aborted",
			failed: "Failed",
		},
	},
	ehealth: {
		uploadReport: "Upload Inbox report (PDF)",
		uploadReportHint: "Process Summary / Exception / Re-grade printed from the eHR Inbox. Image-only PDFs are OCR'd (~30 s).",
		reportDone: "{kind} · {state} · {batches} batch(es), {records} record(s) matched",
		reportKind: "Kind",
		reportTitle: "Title",
		issuedAt: "Issued",
		parseState: "Read",
		matchedBatches: "Batches",
		matchedRecords: "Records",
		lines: "Lines",
		reconcile: "Re-reconcile",
		noReports: "No reports uploaded yet.",
		errorCode: "Error code",
		errorField: "Field",
		rawLine: "As read",
		tabNotifications: "Notifications",
		poll: "Poll eHealth (GPNH)",
		pollHint: "Outbound: fetches consent / key-change / death notifications since the last window and applies them. 24/7.",
		pollDone: "Poll done: {received} received, {applied} applied, {duplicates} duplicates, {unmatched} for unknown patients",
		pendingRepliesTitle: "{n} consent notification(s) still owed a major-key-match reply (7-day clock)",
		colEvent: "Event",
		changes: "Applied changes",
		reply: "Reply",
		replyDue: "due by",
		previewMatch: "Preview match",
		sendReply: "Send reply",
		noReplyDue: "no reply due",
		noNotifications: "No notifications applied yet.",
		scan: "Scan records",
		scanHint: "Registers the project's LABGEN records (new, amended, withdrawn). Local only.",
		scanDone: "Scan done: {scanned} scanned, {registered} registered, {amended} amended, {withdrawn} withdrawn",
		transactions: "Transactions",
		txnDatetime: "Transaction datetime",
		outcome: "Outcome",
		rows: "Emitted rows",
		build: "Build batch",
		buildHint: "Assembles pending records into a signed, encrypted LABGEN batch on disk. Nothing leaves until Upload.",
		buildDone: "Built {name} ({mode}): {included} record(s) included, {excluded} excluded",
		modeAuto: "Mode: automatic",
		noBatches: "No batches built yet.",
		colBatchName: "Batch (HL7 name)",
		colParticipants: "Patients",
		colNotes: "Build notes",
		actions: "Actions",
		files: "Files",
		upload: "Upload (SFTP)",
		checkCollected: "Collected?",
		uploadDone: "Uploaded — records are now DEPOSITED, awaiting a report",
		remoteDir: "Remote folder",
		zipSha: "Zip SHA-256",
		fileKind: "Kind",
		fileName: "File",
		bytes: "Bytes",
		checksum: "SHA-256",
		open: "Open",
		record: "Record",
		refresh: "Refresh",
		colName: "Name",
		colDob: "DOB",
		colSex: "Sex",
		colConsent: "Consent",
		colFlags: "Flags",
		colQuery: "Last PMI Query",
		colEligibleFrom: "Eligible from",
		unknown: "unknown",
		flagDeceased: "deceased",
		flagSuspended: "suspended",
		flagProblem: "problem record",
		neverQueried: "never queried",
		pmiSync: "Sync from patient profiles",
		pmiSyncHint: "Re-derives the PMI identity rows from the Patient Profile form. Local only.",
		pmiSyncDone: "Sync done: {scanned} scanned, {created} created, {updated} updated, {unchanged} unchanged",
		pmiEmpty: "No PMI rows yet — add patients on the Patient Profile form, then sync.",
		majorKeys: "Major keys",
		lastDeposit: "Last deposit",
		documents: "Identity documents",
		docType: "Type",
		docNumber: "Number",
		docNumberNorm: "Normalised",
		docValidity: "Validity",
		docCurrent: "current",
		docSuperseded: "superseded",
		eligibility: "Deposit eligibility",
		eligibleYes: "Eligible",
		eligibleNo: "Not eligible",
		eligibilityNote: "Computed now from live state and the last PMI Query within its freshness bound. Never a stored flag.",
		recordDecision: "Record decision",
		pmiQuery: "Ask eHealth (PMI Query)",
		pmiQueryHint: "Outbound call through the HK egress; eHealth answers weekdays 08:00–18:00 HKT only.",
		pmiQueryDone: "PMI Query completed",
		keyHistory: "Superseded major keys",
		supersededAt: "Superseded at",
		surname: "Surname",
		givenName: "Given name",
		reason: {
			OK_JOINING_CONSENT: "joining consent confirmed by eHealth",
			NO_EHR_NUMBER: "eHealth holds no participant for these keys",
			DECEASED: "patient recorded as deceased",
			CONSENT_REVOKED: "consent to this provider was revoked",
			EMERGENCY_ONLY: "emergency access only (viewer, no deposit)",
			QUERY_STALE: "last PMI Query is older than the freshness bound — re-query",
			QUERY_UNAVAILABLE: "no usable PMI Query result yet — query eHealth",
		},
		intro: "Clinical data upload to the Hong Kong eHealth System (eHRSS). Deposit is a batch channel, not a per-save API: records are held here, packaged per domain, signed and deposited over SFTP, and judged asynchronously by a report that arrives afterwards. A collected batch is NOT an accepted batch.",
		tabRecords: "Records",
		tabBatches: "Batches",
		tabPatients: "PMI patients",
		tabRegister: "Clinical record register",
		registerAllDomains: "All data domains",
		registerHint: "Every record this system holds, per patient, with the batch that carried it to eHealth.",
		registerEmpty: "No clinical records held for this project yet.",
		registerFootnote:
			"Records are created in this system before deposit and carry the batch that uploaded them, evidencing that clinical data reaches eHealth programmatically rather than by manual entry.",
		cntPatients: "Patients",
		cntRecords: "Clinical records",
		cntUploaded: "Uploaded to eHealth",
		cntDomains: "Data domains",
		colSummary: "Record",
		colRecordDate: "Record date",
		colCreatedInEmr: "Created in EMR",
		colUploaded: "Uploaded",
		tabReports: "Reports",
		tabMapping: "Field mapping",
		colRecordKey: "Record key",
		colDomain: "Domain",
		colPatient: "Patient",
		colEhrNumber: "eHR number",
		colTxn: "Txn",
		colState: "State",
		colCreated: "Created in EMR",
		colDeposited: "Deposited",
		colBatch: "Batch",
		colLevel: "Level assigned",
		colMode: "Mode",
		colTransport: "Transport",
		colGenerated: "Generated",
		colRecordCount: "Records",
		stateHeld: "Held",
		stateDeposited: "Deposited",
		stateAccepted: "Accepted",
		stateRejected: "Rejected",
		stateRegraded: "Re-graded",
		stateWithdrawn: "Withdrawn",
		depositPending: "Awaiting a report — deposit is not acceptance",
		notConfigured: "This project has no eHealth deposit target (ehealth_hcp_id is not set), so records can be reviewed here but never deposited.",
		disabledGlobally: "The eHealth feature is switched off on this deployment (imles.ehealth.enabled=false).",
		shadowMode: "Shadow mode — batches are built and recorded but never transmitted.",
		empty: "No eHealth records held for this project yet.",
	},
	ingestion: {
		intro: "Read-only view. Ingestion hardening rolls out via spec §3's three-phase switches (Phase A=dormant / Phase B=shadow / Phase C=enforce). SFTP server is independently gated by <code>imles.ingestion.sftp.enabled</code>. See <code>extract/coche/specs/ingestion-hardening.md</code>.",
		tabChecksum: "Checksum (SHA-256)",
		tabRejections: "Rejection queue",
		tabDedup: "Dedup table",
		tabSftp: "SFTP sessions",
		hashPlaceholder: "Look up by SHA-256 (64 hex)",
		colOssFile: "OSS file",
		colBytes: "Bytes",
		colSource: "Source",
		colUploaded: "Uploaded",
		colFilename: "Filename",
		colReason: "Reason",
		colMode: "Mode",
		colDetail: "Detail",
		colOriginFileId: "Origin file ID",
		colReuseCount: "Reuse count",
		colFirstSeen: "First seen",
		colLastReuse: "Last reuse",
		colUser: "User",
		colAuth: "Auth",
		colOpened: "Opened",
		colClosed: "Closed",
		colUploads: "Uploads",
		colTotalBytes: "Total bytes",
		colCloseReason: "Close reason",
	},
	dbConfig: {
		title: "Database config",
		step1: "Select database model",
		step2: "Select output type",
		step3: "Configure form/document",
		step4: "Configure fields",
		selectedOutput: "Selected output type",
		structuredForm: "Structured form",
		structuredF1: "· Export data with custom forms",
		advFilter: "· Advanced filtering supported",
		univariate: "· Univariate statistical analysis supported",
		crfExport: "· Generate CRF tables from data, export as PDF/Word",
		defaultForm: "Default form",
		defaultF1: "· Display the form with its default structure",
		formConfigTitle: "Project form config",
		formName: "Project form name",
		formCode: "Project form code",
		formOrder: "Project form order",
		visible: "Visible",
		formModelConfigTitle: "Project form model config",
		selectModel: "Select model",
		newModel: "New model",
		colIndex: "No.",
		modelCode: "Model code",
		modelName: "Model name",
		modelDomain: "Model domain",
		modelOrder: "Model order",
		modelConfigTitle: "Project model config",
		modelNameLabel: "Project model name",
		modelCodeLabel: "*Project model code",
		modelCodeLabelReq: "Project model code",
		dontModify: "Do not modify unless necessary",
		deletionMode: "Deletion mode",
		logical: "Logical",
		physical: "Physical",
		modelDescription: "Model description",
		showNoteInput: "Show note input",
		note: "Note",
		sceneType: "Scene type",
		sceneDefault: "Default scene",
		sceneTable: "Table scene",
		sceneTableDialog: "Table dialog scene",
		sceneList: "List scene",
		uploadAttachment: "Upload attachment",
		on: "On",
		off: "Off",
		saveModelAttrs: "Save model attributes",
		editFields: "Edit fields",
		modelFieldConfigTitle: "Project model field config",
		previous: "Previous",
		next: "Next",
		selectedInfo: "Selected info",
		availableInfo: "Available info",
		codeFormatHint: "Enter letters, digits or underscores",
		selectRowFirst: "Select a row before adding",
		enterModelName: "Enter the project model name",
		enterModelCode: "Enter the project model code",
		modelCodeFormat: "Model code may only contain letters, digits and underscores",
		saveFormFirst: "Save the form info first",
		modelCodeExists: "This model code already exists",
	},
	fieldList: {
		colFieldOrder: "Field order",
		colIntegrityScore: "Integrity score",
		colFieldCode: "Field code",
		colFieldName: "Field name",
		colFieldType: "Field type",
		colVisible: "Visible",
		colEditable: "Editable",
		colRequired: "Required",
		colDictValue: "Dictionary value",
		addField: "Add field",
		refField: "Reference field",
		dlgEdit: "Edit",
		dlgAdd: "Add",
		order: "Order",
		noSorting: "No sorting",
		reservedHint: "The following field codes have special meaning and are auto-mapped to the patient info table:",
		colMeaning: "Meaning",
		colDescription: "Description",
		reservedUniqueNote: "<b>card_id</b>, <b>inpatient_id</b> and <b>outpatient_id</b> have a uniqueness constraint — duplicate values are not allowed within the same project, which helps prevent duplicate patient entry.",
		fieldNameZh: "Field name (Chinese)",
		fieldNameEn: "Field name (English)",
		fieldAlias: "Field alias",
		tailLabel: "Tail label",
		refRange: "Reference range",
		refMin: "Min",
		refMax: "Max",
		refRangeHint: "Numeric types only; out-of-range values are flagged abnormal, not blocked",
		refRangeInvalid: "Reference range min cannot exceed max",
		fieldDesc: "Field description",
		controlsVisibility: "Controls visibility",
		controlledFields: "Controlled fields",
		optionCode: "Option code",
		optionName: "Option name",
		controlledFieldCount: "Controlled field count",
		controlledModelCount: "Controlled model count",
		inFormEvent: "In-form event",
		inModelEvent: "In-model event",
		inModelClickEvent: "In-model click event",
		showNoteInput: "Show note input",
		note: "Note",
		subFieldList: "Sub-field list",
		refList: "Reference list",
		selectExisting: "Select existing field",
		colIndex: "No.",
		colModifiedBy: "Modified by",
		colModifiedAt: "Modified at",
		dlgSubEdit: "Edit sub-field",
		dlgSubAdd: "Add sub-field",
		existingFieldList: "Existing field list",
		fieldControlled: "Field-controlled",
		modelControlled: "Model-controlled",
		colFieldId: "Field ID",
		colModelId: "Model ID",
		colModelCode: "Model code",
		colModelName: "Model name",
		refSaved: "Reference relationship saved",
		convertedToSub: "Converted to sub-field",
		none: "None",
		reserved: {
			name: { n: "Name", d: "Patient name" },
			gender: { n: "Gender", d: "0=Female, 1=Male" },
			age: { n: "Age", d: "Patient age" },
			birthday: { n: "Date of birth", d: "Patient birthday" },
			phone: { n: "Mobile", d: "Contact phone" },
			idNum: { n: "ID number", d: "National ID number" },
			cardId: { n: "Admission card no.", d: "Unique constraint, no duplicates" },
			inpatientId: { n: "Outpatient no.", d: "Unique constraint, no duplicates" },
			outpatientId: { n: "Inpatient no.", d: "Unique constraint, no duplicates" },
			admissionTime: { n: "Admission time", d: "Date type" },
			enrollmentTime: { n: "Enrollment time", d: "Date type" },
			diagnosis: { n: "Diagnosis", d: "Diagnosis info" },
			doctorId: { n: "Doctor ID", d: "Linked doctor" },
			doctorName: { n: "Doctor name", d: "Linked doctor name" },
			hospitalName: { n: "Hospital", d: "Hospital name" },
			status: { n: "Patient status", d: "e.g. enrolled, withdrawn" },
			statusCode: { n: "Status code", d: "Code for the status" },
		},
	},
	customColumn: {
		title: "Custom columns",
		searchFieldPh: "Search field name",
		name: "Name",
		order: "Order",
		visible: "Visible",
		description: "Description",
		propertyPath: "Property path",
		selectProperty: "Please select a property",
		colIndex: "No.",
	},
	piiRule: {
		title: "PII rule config",
		currentProject: "Current project",
		refresh: "Refresh",
		readonly: "Read-side anonymisation",
		readonlyDesc: "Rules only apply on data export and cohort search paths; stored data is untouched. KEEP returns the raw value. Roles with the pii.unmask permission can bypass (bypass is audited).",
		addRule: "Add rule",
		preview: "Preview rules",
		saveAll: "Save all changes",
		empty: "No PII rules configured yet",
		colField: "Field code",
		colMode: "Mode",
		colExample: "Example",
		colNote: "Note",
		colOperation: "Actions",
		actDelete: "Delete",
		modeKeep: "Keep raw value (default)",
		modeMask: "Mask",
		modeRedact: "Placeholder",
		modePseudonym: "Project-deterministic pseudonym",
		modeHash: "SHA-256 hash (12 hex)",
		modeSuppress: "Suppress field",
		modeGeneralise: "Bucket / generalise",
		previewMissingInput: "Please fill in field and mode.",
		draftMissingFieldCode: "New rules must have a field code.",
		saveSummary: "Saved {saved} · deleted {deleted}",
	},
	analytics: {
		overviewTitle: "Analytics overview",
		datasetTitle: "Datasets",
		encodingTitle: "Field encoding",
		selectionTitle: "Field selection",
		algorithmTitle: "Algorithm runs",
		reportTitle: "Statistical report",
		researchOverviewTitle: "Research overview",
		libraryTitle: "Library",
		topicsTitle: "Topic recommendations",
		workbenchTitle: "Workbench",
		refresh: "Refresh",
		empty: "No analytics data yet",
		statSamples: "Samples",
		statFields: "Fields",
		statAnalyses: "Analyses",
		recentAnalyses: "Recent analyses",
		colName: "Name",
		colType: "Type",
		colCreatedAt: "Created",
		colOperation: "Actions",
		actView: "View",
		viewDetail: "View details",
		typeAlgorithm: "Algorithm",
		typeReport: "Report",
		errorProject: "Project not found",
		errorFetch: "Failed to load data",
	},
	clinic: {
		operationOverview: "Operations overview",
		appointments: "Appointment add-ons",
		checkins: "Check-ins",
		chatHistory: "Chat history",
		users: "Outpatient users",
		refresh: "Refresh",
		today: "Today",
		last7d: "Last 7d",
		last30d: "Last 30d",
		last90d: "Last 90d",
		custom: "Custom",
		dateSep: "to",
		startDate: "Start",
		endDate: "End",
		kpiTotalUsers: "Total users",
		kpiNewUsers: "New users (period)",
		kpiActiveUsers: "Active users",
		kpiDeactivated: "Deactivated accounts",
		kpiSnapshot: "Snapshot",
		kpiMessages: "Messages (period)",
		kpiConversations: "Conversations (period)",
		kpiUploads: "Uploads (period)",
		kpiFollowupMessages: "Follow-up messages (period)",
		recentRegistrations: "Recent registrations",
		// Outpatient users list
		searchPlaceholder: "Search nickname / phone / openid",
		searchBtn: "Search",
		showDeleted: "Show deleted accounts",
		totalCount: "{n} total",
		emptyUsers: "No users",
		colUser: "User",
		colContact: "Contact",
		colLoginType: "Login",
		colLastLogin: "Last login",
		colStatus: "Status",
		colRemark: "Remark",
		colActions: "Actions",
		statusDeleted: "Deleted",
		statusActive: "Active",
		statusDisabled: "Disabled",
		loginWechat: "WeChat",
		loginPassword: "Password",
		loginBoth: "Both",
		internalFlag: "Early access",
		disable: "Disable",
		restore: "Restore",
		disableTitle: "Disable account",
		restoreTitle: "Restore account",
		disableConfirm: "About to {action} user {name}.",
		disableNote: "Once disabled, the user will see \"Your account has no access\" and cannot continue; existing data is kept.",
		reasonLabel: "Reason (optional, shown to the user)",
		confirm: "Confirm",
		cancel: "Cancel",
		save: "Save",
		opSuccess: "Done",
		opFailed: "Operation failed",
		loadFailed: "Failed to load",
		internalOn: "Early access enabled",
		internalOff: "Early access disabled",
		viewDetail: "Detail",
		// User detail page
		userDetail: "User detail",
		backToList: "Back to list",
		profile: "Profile",
		loginCount: "Login count",
		createdAt: "Registered",
		lastLoginIp: "Login IP",
		patientTimelines: "Patient timelines",
		noPatients: "No patient records",
		correctionHint: "Timelines are system-generated and doctor-correctable; the user's original chats and profile are read-only.",
		tabConversations: "Conversations",
		tabAppointments: "Add-on requests",
		tabCheckins: "Check-ins",
		tabAssessments: "Assessments",
		convTitle: "Conversation",
		convTheme: "Topic",
		convPending: "Pending",
		convMessages: "Messages",
		convLastActive: "Last active",
		patient: "Patient",
		// Patient timeline component
		patientInfo: "Patient info",
		patientName: "Name",
		patientGender: "Gender",
		patientDob: "Date of birth",
		hospitalCards: "Hospital cards",
		baseline: "Baseline",
		followUps: "Timeline events",
		viewSource: "View source",
		assessmentSource: "Source: assessment",
		timelineMissing: "No patient timeline found",
		correctedBadge: "Corrected by doctor",
		correctedAt: "Corrected at",
		editEvent: "Edit",
		deleteEvent: "Delete",
		editEventTitle: "Correct timeline event",
		eventDate: "Date",
		eventType: "Event type",
		removeField: "Remove field",
		undoRemove: "Undo",
		complexFields: "Complex fields",
		complexFieldsNote: "Structured field — edit as JSON; validated before saving.",
		invalidJson: "Invalid JSON in {key}; please fix it before saving",
		addField: "Add field",
		fieldKey: "Field key",
		fieldValue: "Value",
		add: "Add",
		reservedFieldKey: "Reserved field name",
		duplicateFieldKey: "Field already exists",
		noChanges: "No changes detected",
		correctionSaved: "Correction saved",
		correctionFailed: "Operation failed, please retry",
		deleteEventTitle: "Delete confirmation",
		deleteEventConfirm: "Delete this timeline event ({type} {date})? This cannot be undone.",
		eventDeleted: "Deleted",
	},
	discern: {
		title: "AI recognition",
		uploader: "Uploaded by:",
		userType: "User type:",
		identifyStatus: "OCR status:",
		confirmStatus: "Review status:",
		input: "Type here",
		select: "Select…",
		userDoctor: "Doctor",
		userPatient: "Patient",
		userSys: "Admin",
		statusUnfinished: "Pending",
		statusFinished: "Done",
		statusPending: "Pending review",
		statusConfirmed: "Reviewed",
		searchBtn: "Search",
		resetBtn: "Reset",
		qrCode: "QR code",
		batchUpload: "Batch upload",
		colIndex: "No.",
		colUploader: "Uploaded by",
		colUserType: "User type",
		colProject: "Project",
		colFileCount: "Files",
		colUploadTime: "Uploaded",
		colIdentifyStatus: "OCR",
		colIdentifyTime: "OCR time",
		colConfirmStatus: "Review",
		colConfirmUser: "Reviewer",
		colConfirmTime: "Reviewed",
		colOperation: "Actions",
		actView: "View",
		actConfirm: "Review",
		viewTitle: "AI recognition detail",
		batchUploadTitle: "Batch upload",
		dropFiles: "Drop files here, or",
		clickUpload: "click to upload",
		fileTip: "JPG/PNG only, max 10MB per file",
		startUpload: "Upload",
	},
	governance: {
		title: "Approval inbox",
		myTitle: "My requests",
		refresh: "Refresh",
		colId: "Request ID",
		colType: "Type",
		colRequester: "Requester",
		colCreatedAt: "Submitted",
		colStatus: "Status",
		colOperation: "Actions",
		actView: "View",
		actApprove: "Approve",
		actReject: "Reject",
		statusPending: "Pending",
		statusApproved: "Approved",
		statusRejected: "Rejected",
		statusCancelled: "Cancelled",
		drawerTitle: "Request detail",
		approve: "Approve",
		reject: "Reject",
		comment: "Comment",
		commentPh: "Enter your decision rationale",
		noPendingStep: "No pending approval step",
		emptyCommentConfirm: "A rationale is recommended when rejecting. Submit with an empty comment?",
		confirmTitle: "Confirm",
		toastApproved: "Approved",
		toastRejected: "Rejected",
		quickConfirmBody: "{action} request #{id}?",
		quickConfirmTitle: "Confirm action",
	},

	consent: {
		admin: {
			tabTemplates: "Templates",
			tabSignatures: "Doctor signatures",
			noProject: "No project in the URL — open this page from Project management.",
			noPermission: "You do not have consent template management rights; contact an administrator.",
			templateHint: "One published version per family; a published template cannot be edited — create a new version instead.",
			templateEmpty: "This project has no consent templates yet",
			newTemplate: "New template",
			colFamily: "Family",
			colName: "Name",
			colVersion: "Version",
			colStatus: "Status",
			colSource: "Source",
			colPages: "Pages",
			colUpdated: "Updated",
			colActions: "Actions",
			status: {
				DRAFT: "Draft",
				ACTIVE: "Published",
				RETIRED: "Retired",
			},
			actZones: "Mark zones",
			actPreview: "Preview",
			actEdit: "Edit",
			actPublish: "Publish",
			actRetire: "Retire",
			actNewVersion: "New version",
			actDelete: "Delete",
			familyHint: "Family code of this consent form, e.g. F2F (face to face) or PHONE",
			versionHint: "e.g. V3.0a",
			sourcePdf: "PDF upload",
			sourceText: "Plain text",
			file: "Template file",
			chooseFile: "Choose PDF",
			fileHint: "Unencrypted PDF files only",
			textBody: "Body",
			textHint: "A PDF is generated from this text, with a standard signature page appended",
			remark: "Remark",
			effectiveDate: "Effective date",
			effectiveDatePlaceholder: "Pick a date",
			editMeta: "Edit template details",
			createIncomplete: "Family, name and version are all required",
			needPdf: "Choose the PDF template file",
			needText: "Enter the template body",
			createDone: "Template created as a draft",
			saveDone: "Saved",
			publishConfirm: "Publish \"{name}\"? The published version of the same family will be retired automatically.",
			publishDone: "Template published",
			retireConfirm: "Retire \"{name}\"? It will no longer be offered for signing.",
			retireDone: "Template retired",
			newVersionBody: "Copy {version} into a new draft — enter the new version label",
			versionRequired: "A version label is required",
			newVersionDone: "New draft version created",
			deleteConfirm: "Delete \"{name}\" {version}? This cannot be undone.",
			deleteDone: "Template deleted",
			zoneTitle: "Mark signature zones",
			zoneList: "Zones",
			zoneEmpty: "No zones marked yet",
			zoneNoSelection: "Drag on the page to create a zone, or click an existing one to edit it",
			zoneReadonly: "Read-only",
			zoneReadonlyHint: "Published and retired templates cannot be re-marked — create a new version",
			zoneDrawHint: "Drag empty space to create; drag a box to move; drag a corner to resize; Delete removes the selection",
			zoneDirty: "Unsaved changes",
			zoneSave: "Save zones",
			zoneSaved: "Zones saved",
			zoneDiscardTitle: "Discard unsaved changes?",
			zoneDiscardBody: "The zones have not been saved; closing now loses the changes.",
			zoneKey: "Key",
			zoneKeyHint: "Lower-case letters, digits and underscores, 1-32 characters; matches the signature image at signing time",
			zoneKeyInvalid: "Lower-case letters, digits and underscores only, 1-32 characters",
			zoneKeyInvalidAt: "Zone key \"{key}\" is invalid: lower-case letters, digits and underscores only, 1-32 characters",
			zoneKeyDuplicate: "Zone key \"{key}\" is used twice",
			zoneType: "Type",
			zoneRole: "Role",
			zoneLabel: "Label",
			zoneSource: "Auto-fill",
			zonePage: "Page",
			zoneFormat: "Format",
			zoneFormatHint: "e.g. yyyy年MM月dd日 — required for date and time zones",
			zoneRect: "Position and size (page fractions 0-1)",
			zoneRectHint: "x/y is the top-left corner, w/h the size — all as a fraction of the page",
			zoneRequired: "Required",
			zoneMask: "Mask",
			zoneMaskHint: "Paint the area white before stamping — covers preprinted text",
			zoneDelete: "Delete this zone",
			prevPage: "Previous",
			nextPage: "Next",
			type: {
				SIGNATURE: "Signature",
				DATE: "Date",
				DATETIME: "Date and time",
				DATETIME_RANGE: "Time range",
				TEXT: "Text",
				CHECKBOX: "Checkbox",
			},
			source: {
				none: "None",
				patient_no: "Participant screening number",
				patient_name: "Participant name",
				doctor_name: "Investigator name",
				signed_date: "Signing date",
			},
			signatureHint: "Signature images for project members; the 研究人员 zone always uses the signer's own signature.",
			memberEmpty: "This project has no members yet",
			colNickname: "Name",
			colUsername: "Account",
			colSignature: "Signature",
			noSignature: "Not set",
			actUpload: "Upload",
			actDraw: "Draw",
			actDeleteSignature: "Delete",
			chooseImage: "Choose image",
			uploadHint: "A PNG with a transparent background works best; tick 去除白底 for a white-background scan.",
			needImage: "Choose a signature image",
			needDrawing: "Draw the signature first",
			signatureSaved: "Signature saved",
			signatureDeleted: "Signature deleted",
			deleteSignatureConfirm: "Delete the signature of {name}?",
		},
		panel: {
			title: "Consent Form",
			sign: "Sign Consent Form",
			empty: "No signed consent yet",
			colTemplate: "Template",
			colVersion: "Version",
			colSignedDate: "Signed On",
			colDoctor: "Investigator",
			colStatus: "Status",
			view: "View",
			download: "Download",
			voidAction: "Void",
			voidPromptTitle: "Void Signed Consent",
			voidPromptBody: "A voided record no longer counts as valid consent; the file itself is kept. Please give a reason ({template}).",
			voidReasonPlaceholder: "Reason for voiding, up to 200 characters",
			voidReasonRequired: "A reason is required",
			voidReasonTooLong: "The reason cannot exceed 200 characters",
			voidDone: "Record voided",
		},
		status: {
			SIGNED: "Signed",
			VOID: "Voided",
		},
		role: {
			PATIENT: "Participant",
			DOCTOR: "Investigator",
			GUARDIAN: "Guardian",
			WITNESS: "Impartial Witness",
			OTHER: "Other Details",
		},
		dialog: {
			title: "Sign Consent Form",
			stepTemplate: "Select Template",
			stepRead: "Read in Full",
			stepSign: "Sign",
			prev: "Back",
			next: "Next",
			submit: "Confirm & Sign",
			selectTemplateHint: "Choose the consent form version to sign.",
			readHint: "Read the full document with the participant; scroll to the last page to continue.",
			readEnd: "End of document",
			pageOf: "Page {n} of {total}",
			signedDate: "Signed Date",
			signedDateHint: "Defaults to today; editable.",
			followsSignedDate: "Follows the signed date above",
			rangeStart: "Start time",
			rangeEnd: "End time",
			noZones: "This template has no marked signature zones yet — please contact the project administrator.",
			optionalSection: "If applicable",
			expand: "Expand",
			collapse: "Collapse",
			signature: "Signature",
			submitSuccess: "Consent signed",
			templateLoadFailed: "Failed to load the template",
			popupBlocked: "Signed. Your browser blocked the new window — use View in the list below to open it.",
		},
		doctor: {
			stored: "Saved signature",
			redraw: "Sign again",
			useStored: "Use saved signature",
			saveAsMine: "Save as my signature",
			noStored: "You have no saved signature yet — tick the box to save this one.",
		},
		pad: {
			tabDraw: "Draw",
			tabUpload: "Upload image",
			tabType: "Type name",
			drawHint: "Sign inside the box below",
			upload: "Choose image",
			whiteToAlpha: "Drop white background",
			namePlaceholder: "Enter name",
			undo: "Undo",
			clear: "Clear",
			required: "Required",
			optional: "Optional",
			imageFailed: "Could not read the image",
			notImage: "Please choose an image file",
		},
		validate: {
			signatureRequired: "Please complete the \u201c{label}\u201d signature",
			valueRequired: "Please fill in \u201c{label}\u201d",
			rangeInvalid: "The end time of “{label}” cannot be earlier than its start time",
		},
	},
	basicInfo: {
		doctor: "Attending doctor",
		maskedDoctor: "*** Doctor",
		hospital: "Institution",
		maskedHospital: "**** Hospital",
		input: "Type here",
		enrollDate: "Enrollment date",
		select: "Select…",
		status: "Status",
		diagnosis: "Diagnosis",
		diagnosisPh: "Enter diagnosis",
	},
	patientInfo: {
		patientNo: "Patient ID",
		randomNo: "Random ID",
		name: "Name",
		gender: "Gender",
		age: "Age",
		ageUnit: "yrs",
		dob: "Date of birth",
		phone: "Phone",
		idNumber: "ID number",
		project: "Project",
		enrollDate: "Enrolled",
		status: "Status",
		doctor: "Attending doctor",
		hospital: "Institution",
	},
	followupRecord: {
		recordTitle: "Follow-up records",
		newRecord: "New visit",
		emptyHint: "No follow-up records yet",
		actView: "View",
		actEdit: "Edit",
		actDelete: "Delete",
		visitName: "Visit",
		dueDate: "Due",
		actualDate: "Completed",
		statusPending: "Pending",
		statusOverdue: "Overdue",
		statusDone: "Done",
		confirmCancel: "Cancel this visit?",
		menuSelect: "Pick template",
		menuDelete: "Delete template",
		menuAdd: "Add ad-hoc visit",
		dialogSelectTitle: "Pick a follow-up plan template",
		dialogAddTitle: "Add ad-hoc visit",
		fieldProjectName: "Project:",
		fieldTemplate: "Template:",
		fieldStart: "Start date:",
		select: "Select…",
		datePh: "Pick a date",
		ruleTemplate: "Pick a template",
		ruleStart: "Pick a start date",
		generatePlan: "Generate plan",
		confirmDelete: "This cannot be undone. Delete?",
		confirmDeleteOne: "Delete this follow-up record? This cannot be undone.",
		dialogTipTitle: "Confirm",
		deleteSuccess: "Deleted",
		dialogEditTitle: "Edit follow-up record",
		fieldVisitName: "Visit name",
		fieldVisitType: "Visit type",
		typePlan: "Planned visit",
		typeNoPlan: "Ad-hoc visit",
		fieldPlan: "Follow-up plan",
		fieldConfig: "Plan node",
		namePh: "Enter visit name",
		rulePlan: "Pick a follow-up plan",
		ruleConfig: "Pick a plan node",
		editSuccess: "Saved",
	},
	upgradation: {
		dialogTitle: "Upgrade plan",
		selectLevel: "Select plan",
		level: "Plan",
		duration: "Duration",
		monthly: "{n} month(s)",
		yearly: "{n} year(s)",
		price: "Price",
		discount: "Verified users save 50%",
		payNow: "Pay now",
		paySuccess: "Payment successful",
		payFailed: "Payment failed",
		qrTip: "Scan with WeChat to pay",
	},
	fileUpload: {
		click: "Click to upload",
		drop: "or drop files here",
		tip: "JPG / PNG / PDF supported",
		preview: "Preview",
		download: "Download",
		remove: "Remove",
		removeConfirm: "Remove this file?",
		uploading: "Uploading…",
		uploaded: "Uploaded",
		uploadFailed: "Upload failed",
		uploadFailedWithReason: "Upload rejected: {reason}",
		duplicateRejected: "Duplicate file rejected — this file has already been uploaded for this patient.",
		exceed: "Too many files",
		view: "View",
		upload: "Upload",
		dialogUploadTitle: "Upload Files",
		dialogViewTitle: "View Files",
		cancelUpload: "Cancel Upload",
		selectFile: "Choose File",
		dragHint: "Drag files here, or",
		clickToSelect: "click to select",
		aiOcr: "AI Recognition",
		submitted: "Submitted",
		selectAll: "Select All",
		selected: "{n} selected",
		emptyData: "No data",
	},
	patientList: {
		patientNoOrName: "Patient ID / name:",
		enrollDate: "Enrolled:",
		startDate: "Start",
		endDate: "End",
		center: "Centre:",
		searchPlaceholder: "Type here",
		searchKeyword: "Type to search",
		searchBtn: "Search",
		resetBtn: "Reset",
		colIndex: "No.",
		colCompleteness: "Completeness",
		colOperation: "Actions",
		dragReorderTip: "Drag to reorder columns (this browser only)",
		actDetail: "Patient",
		actFollowup: "Follow-up",
		actImaging: "Imaging",
		actImagingWorkspace: "Imaging workspace",
		actTimeSeries: "Time series",
		actDelete: "Delete",
		deleteSuccess: "Deleted",
		deleteConfirm: "Delete this patient record? This cannot be undone.",
		deleteTitle: "Confirm",
		add: "Add patient",
		export: "Export",
		batchEnroll: "Batch enroll",
		import: "Import",
		advancedFilter: "Advanced filter",
		colPatientNo: "Patient ID",
		colName: "Name",
		colGender: "Gender",
		colBirth: "Date of birth",
		colAge: "Age",
		colEnrollDate: "Enrolled",
		colCenter: "Centre",
		genderMale: "Male",
		genderFemale: "Female",
		genderUnknown: "Unknown",
		ageYears: "yrs",
		viewSource: "Source",
	},
	patientDetail: {
		add: "Add patient",
		edit: "Edit patient",
		fileView: "Patient file view",
		basicInfo: "Basic info",
		save: "Save",
		saveDraft: "Save draft",
		discard: "Discard changes",
		nextForm: "Next",
		prevForm: "Back",
		visitRecords: "Visits",
		followups: "Follow-ups",
		documents: "Imaging / files",
		newVisit: "New visit",
		fieldRequired: "Required",
	},
	retrieval: {
		title: "Data retrieval",
		exportTitle: "Data retrieval — export",
		searchPlaceholder: "Type to search",
		newQuery: "New query",
		runQuery: "Run query",
		exportResult: "Export results",
		conditions: "Filters",
		results: "Results",
		colIndex: "No.",
		colName: "Query name",
		colCreatedAt: "Created",
		colOperation: "Actions",
		actView: "View",
		actEdit: "Edit",
		actDelete: "Delete",
		actExport: "Export",
		actRun: "Run",
		deleteGroup: "Delete group",
		selectValues: "Select value(s)",
		enterValue: "Enter a value",
		fieldTreeFailed: "Couldn't load the field list",
		selectAnalysisField: "Pick a field to analyse first",
		condition: {
			is: "Equals",
			ne: "Not equals",
			gt: "Greater than",
			gte: "Greater than or equal",
			lt: "Less than",
			lte: "Less than or equal",
			regex: "Fuzzy match",
			exists: "Has value",
			in: "In list",
			nin: "Not in list",
			all: "Contains all",
			yes: "Yes",
			no: "No",
			and: "Match all conditions",
			or: "Match any condition",
			nor: "Match none of the conditions",
		},
		stats: {
			title: "Result statistics",
			chart: "Chart",
			chartTypePlaceholder: "Select chart type",
			startDate: "Start date",
			endDate: "End date",
			startDatePlaceholder: "Select start date",
			endDatePlaceholder: "Select end date",
			barChart: "Bar chart",
			pieChart: "Pie chart",
			sampleSize: "Sample size",
			max: "Max",
			min: "Min",
			median: "Median",
			avg: "Mean",
		},
		exportPage: {
			searchConditions: "Search conditions",
			saveAsTemplate: "Save as template",
			resultList: "Search results",
			colPatientNo: "Patient ID",
			colPatientName: "Patient name",
			colEnrollmentDate: "Enrollment date",
			colAge: "Age",
			colBirthday: "Date of birth",
			colDoctor: "Attending doctor",
			colEnrollmentStatus: "Enrollment status",
			colLastUpdated: "Last updated",
			colUpdatedBy: "Updated by",
			colDataManage: "Data",
			patientDetail: "Patient details",
			followUpDetail: "Follow-up details",
			templateNamePlaceholder: "Enter a template name",
			templateNameRequired: "Please enter a template name",
			templateSaved: "Template saved",
			joinSubProject: "Enrol into sub-project",
			existingSubProjects: "Existing sub-projects",
			subProjectName: "Sub-project name",
			projectStartDate: "Project start date",
			projectEndDate: "Project end date",
			enrolledCount: "Enrolled",
			actEnrol: "Enrol",
			addSubProject: "Add sub-project",
			basicInfo: "Basic info",
			rootProjectName: "Root project name",
			projectLeader: "Project lead",
			leaderUnit: "Lead's unit",
			projectGoal: "Project goal",
			selectSubProject: "Please select a sub-project",
		},
		exportDialog: {
			title: "Data export",
			exportAll: "Export all forms and models",
			exportPartial: "Export selected forms and models",
			selectForms: "Select the forms and models to export",
			approvalConfirm: "Exports from this project require approval before download. Submit an export request?",
			approvalTitle: "Approval required",
			submitRequest: "Submit request",
			requestId: "Request ID",
			status: "Status",
			requestPending: "Your export request is awaiting reviewer approval. Track its progress in My Requests.",
			requestSubmitted: "Export request submitted",
			goToMyRequests: "Go to My Requests",
		},
	},
	analysis: {
		title: "Data analysis",
		runAnalysis: "Run analysis",
		results: "Results",
		exportResult: "Export report",
		emptyHint: "Pick fields first, then run the analysis.",
	},
	projectManage: {
		title: "Project list",
		searchPlaceholder: "Search by project name",
		clearModelCache: "Clear model cache",
		clearModelCacheConfirm:
			"Clear all model caches? Users will see a one-off slowdown on the first load afterwards.",
		clearModelCacheTip: "Heads up",
		clearModelCacheSuccess: "Cache cleared. {n} entries removed.",
		newProject: "New project",
		colProjectId: "Project ID",
		colProjectName: "Project",
		colProjectLeader: "Project lead",
		colProjectTerm: "Term",
		colFollowupData: "Follow-up data",
		colViewInfo: "View info",
		colMainCenter: "Lead centre",
		colOperation: "Actions",
		actEdit: "Edit",
		actScene: "Scenario",
		actDatabase: "Database config",
		actFollowup: "Follow-up config",
		actPermissions: "Members & permissions",
		actSubCenter: "Sub-centres",
		actSubProject: "Sub-projects",
		actSchema: "Initial schema",
		actAgent: "Agent config",
		actMetadataHistory: "Metadata history",
		actLifecycle: "Lifecycle & retention",
		actPiiRule: "PII rule registry",
		actConsent: "Consent forms",
		grpSetup: "Setup",
		grpData: "Data",
		grpGovernance: "Governance",
		grpStructure: "Structure",
		lostFollowups: "Orphaned follow-up plans: {n}",
		fixData: "Fix data",
		patientCount: "Patients: {p}; view rows: {v};",
		patientViewMismatch: "--- mismatch ---",
		buildStatus: "Build status: {s};",
		buildBusy: "Building view…",
		buildIdle: "Idle",
		startTime: "Started: {t};",
		endTime: "Ended: {t};",
		execResult: "Result: {r};",
		execSuccess: "Success",
		execFailed: "Failed",
		rebuildView: "Rebuild view",
		appendView: "Patch view",
		recalcCompleteness: "Recalc completeness",
		opSent: "Request submitted",
		recalcDone: "Recalc complete. {n} patients processed.",
		dialogBaseTitle: "Basic info",
		dialogSceneTitle: "Scenario",
		fieldProjectName: "Project name",
		fieldProjectCode: "Project code",
		fieldProjectLeader: "Project lead",
		fieldLeadCenter: "Lead unit",
		fieldStartDate: "Start date",
		fieldEndDate: "End date",
		fieldTarget: "Goals",
		fieldLeaderUnit: "Lead unit",
		fieldCompanyLogo: "Company logo (horizontal)",
		fieldSquareLogo: "Square logo (icon)",
		placeholderSelect: "Select…",
		fieldSpecialty: "Specialty",
		fieldDisease: "Disease",
		fieldSoftwareEnv: "Software surfaces",
		envWeb: "Web",
		envDoctor: "Doctor mini-app",
		envPatient: "Patient mini-app",
		fieldLoginUrl: "Project login URL",
		fieldLoginName: "Project login name",
		fieldLoginImage: "Project login image",
		searchPlaceholderRemote: "Type to search",
	},
	equity: {
		accountInfo: "Account info",
		username: "Username:",
		realNameAuth: "Real-name verification:",
		modify: "Edit",
		notAuthHint: "Real-name verification incomplete — half-price discount unavailable.",
		goAuth: "Verify now",
		levelExpire: "Plan valid until: {date}",
		upgrade: "Upgrade plan",
		memberRights: "Plan benefits",
		categoryProjectMgmt: "Project management",
		categoryAiCollect: "AI data capture",
		categoryAiAnalysis: "AI data analysis",
		categoryIp: "IP services",
		categoryResearch: "Research services",
		rightCreateProject: "Create projects",
		rightCustomForm: "Custom forms",
		rightFollowup: "Follow-up management",
		rightEnrollment: "Enrollment status",
		rightSubProject: "Sub-projects",
		rightUnivariate: "Univariate statistics",
		rightSearch: "Data retrieval",
		rightExport: "Data export",
		rightHistorical: "Historical re-enrollment",
		rightAutoEnroll: "Auto eligibility check",
		rightCrfGen: "Auto-generate CRFs",
		rightCrfFill: "Auto-fill CRFs",
		rightPathology: "Auto-generate pathology reports",
		rightFollowupChat: "Interactive follow-up",
		rightAiSearch: "AI search",
		rightAiStat: "AI statistics",
		rightAiExport: "AI filtered export",
		rightAiEnroll: "AI eligibility",
		rightIpFile: "IP filing",
		rightJointProject: "Joint research filing",
		basicMember: "Basic plan",
		smartMember: "Smart plan",
		joint1Software: "1 free joint copyright filing",
		joint2Software: "2 free independent copyright filings",
		jointAiProject: "Eligible to join the AI medical research consortium",
		currentLevel: "Current plan",
		dialogAuthTitle: "Identity verification",
	},
	order: {
		searchPlaceholder: "Search by order number",
		orderList: "Orders",
		colIndex: "No.",
		colOrderNo: "Order #",
		colPaymentTime: "Paid at",
		colPaymentFees: "Amount",
		colPaymentMethod: "Method",
		methodWechat: "WeChat",
		colContent: "Item",
		colStatus: "Status",
		colInvoiceStatus: "Invoice",
		colOperation: "Actions",
		actInvoice: "Issue invoice",
		statusCreated: "Awaiting payment",
		statusPayed: "Paid",
		statusUsed: "Redeemed",
		invoiceNotIssued: "Not issued",
		invoiceIssued: "Issued",
		dialogTitle: "Invoice details",
		titleSection: "Header",
		fieldAmount: "Invoice amount",
		amountUnit: "RMB",
		fieldHeaderType: "Header type",
		typePersonal: "Personal / non-enterprise",
		typeEnterprise: "Enterprise",
		fieldInvoiceType: "Invoice type",
		invoiceTypeValue: "Standard VAT e-invoice",
		fieldHeader: "Invoice header",
		placeholderInput: "Type here",
		placeholderHeader: "Enter the invoice header",
		fieldTaxNumber: "Tax ID",
		placeholderTaxNumber: "Enter a 15–20 character tax ID",
	},
	subProjectManage: {
		title: "Sub-project list",
		breadCrumb: "Project management / {parent}",
		newSubProject: "New sub-project",
		searchPlaceholder: "Search by sub-project name",
	},
	projectList: {
		projectCode: "Project Code",
		centerCount: "Number of Centres",
		patientCount: "Enrolled Patients",
		subProjects: "Sub-projects",
		openProject: "Open Project",
		emptyHint: "You don't have any projects yet — create one to get started.",
		createProject: "Create Project",
		noticeSystem: "System Notice",
		noticeOcr: "OCR Recognition",
		noticeChallenge: "Data Challenge",
	},
	projectHead: {
		projectName: "Project",
		rootProjectName: "Root project",
		subProjectName: "Sub-project",
		parentProject: "Parent cohort",
		specialty: "Specialty",
		disease: "Disease",
		formConfig: "Form configuration",
		followUpConfig: "Follow-up configuration",
		schemaSnapshot: "Schema snapshots",
	},
	home: {
		leadCentre: "Lead Centre",
		maskedHospital: "**** Hospital",
		projectLead: "Project Lead",
		projectTerm: "Project Term",
		pendingReply: "Pending Replies",
		clickToReply: "Click to view & reply →",
		totalCases: "Total Cases",
		newCasesThisMonth: "New Cases (This Month)",
		avgCompleteness: "Avg. Completeness",
		followUpOverdue: "Follow-ups Overdue",
		view: "View",
		notifications: "Project Notifications",
		index: "No.",
		notificationType: "Type",
		notificationContent: "Content",
		count: "Count",
		enrollmentTrend: "Enrollment",
		genderRatio: "Gender",
		ageDistribution: "Age Distribution",
	},
};
